const STORAGE_KEY = 'onboarding_survey_responses';

export const surveyStorage = {
  /**
   * Load survey responses from localStorage
   * @returns {Object|null} Saved survey data or null if none exists
   */
  loadResponses: () => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      console.error('Error loading survey responses:', error);
      return null;
    }
  },

  /**
   * Save survey responses to localStorage
   * @param {Object} data - Survey response data to save
   */
  saveResponses: (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving survey responses:', error);
    }
  },

  /**
   * Clear saved survey responses
   */
  clearResponses: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing survey responses:', error);
    }
  }
};

